var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6932 23.0836H13.0342V17.7655C13.0342 11.1179 18.3523 5.7998 24.9999 5.7998C30.9827 5.7998 36.1679 10.3202 36.8326 16.303L34.1736 16.5689C33.6418 11.9156 29.6532 8.45885 24.9999 8.45885C19.8147 8.45885 15.6932 12.5804 15.6932 17.7655V23.0836Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6359 45.6853H14.3636C12.1034 45.6853 10.375 43.9569 10.375 41.6968V25.7425C10.375 23.4823 12.1034 21.7539 14.3636 21.7539H35.6359C37.8961 21.7539 39.6245 23.4823 39.6245 25.7425V41.6968C39.6245 43.9569 37.8961 45.6853 35.6359 45.6853ZM14.3636 24.413C13.5659 24.413 13.034 24.9448 13.034 25.7425V41.6968C13.034 42.4945 13.5659 43.0263 14.3636 43.0263H35.6359C36.4337 43.0263 36.9655 42.4945 36.9655 41.6968V25.7425C36.9655 24.9448 36.4337 24.413 35.6359 24.413H14.3636Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0008 32.3904C26.4694 32.3904 27.6599 31.1999 27.6599 29.7313C27.6599 28.2628 26.4694 27.0723 25.0008 27.0723C23.5323 27.0723 22.3418 28.2628 22.3418 29.7313C22.3418 31.1999 23.5323 32.3904 25.0008 32.3904Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6639 29.7305H24.3344L23.0049 37.7076H26.9935L25.6639 29.7305Z",
    fill: "white"
  })));
};
export default SvgUnlock;